<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛考务管理</el-breadcrumb-item>
      <el-breadcrumb-item>练习题成绩查询</el-breadcrumb-item>
      <el-breadcrumb-item>答题详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
      <!-- <div v-for="(item, index) in answerResultData" :key="index"> -->
        <el-card style="margin-top: 15px">
        <el-descriptions border>
        <el-descriptions-item label="当前赛季">{{
          info.season
        }}</el-descriptions-item>
        <el-descriptions-item label="试卷名称">{{
          info.formName
        }}</el-descriptions-item>
        <el-descriptions-item label="答题状态">
          <template>
            <el-tag type="danger" v-if="info.answerStatus === 2" size="mini"
              >进行中</el-tag
            >
            <el-tag
              type="success"
              v-else-if="info.answerStatus === 1"
              size="mini"
              >已完成</el-tag
            >
            <span v-else>-</span>
          </template></el-descriptions-item
        >
        <el-descriptions-item v-if="info.answerStatus === 1" label="交卷时间">{{
          info.createTime
        }}</el-descriptions-item>
        <el-descriptions-item label="本轮成绩"><span style="color: orange">{{
          info.score
        }}</span></el-descriptions-item>
        </el-descriptions>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="resultList"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            border
            stripe
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="用户答案" prop="userAnswer"></el-table-column>
            <el-table-column label="系统答案" prop="questionAnswer"></el-table-column>
            <el-table-column label="是否正确" type="isRight">
              <template slot-scope="scope">
                <el-tag
                  type="success"
                  v-if="scope.row.isRight === '1'"
                  size="mini"
                  >正确</el-tag
                >
                <el-tag
                  type="danger"
                  v-else-if="scope.row.isRight === '0'"
                  size="mini"
                  >错误</el-tag
                >
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      <!-- </div> -->
  </div>
</template>

<script>

export default {
  data () {
    return {
      resultList: [],
      info: {},
      id: ''
    }
  },
  created () {
    console.log(this.$route.query)
    this.id = this.$route.query.id
    this.seasonHandleChange()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    seasonHandleChange () {
      this.$http.get('quiz/queryAnswerRaceScheduleById', { params: { id: this.id } }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(res.data.results)
          console.log(data)
          this.resultList = data
          this.info = res.data
          data.forEach(item => {
            if (item.userAnswer.includes('[') && item.userAnswer.includes(']')) {
              item.userAnswer = JSON.parse(item.userAnswer).join(',')
            }
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
